import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigurationGroupDeviceType } from '@casops/store/apis/commonModels';

export const useCompatibilityOptions = (): DropdownItemProps<ConfigurationGroupDeviceType>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.values(ConfigurationGroupDeviceType).map(deviceType => ({
      key: deviceType,
      value: deviceType,
      stringValue: deviceType,
      label: t(`Compatibility.${deviceType}`),
    }));
  }, [t]);
};
